import { useDispatch } from "react-redux";
import { openPopup} from "../../store/popupSlice" 
import { Link } from 'react-router-dom';

export default function BespokeEducation() {
  const dispatch=useDispatch();
  return (
    <>
      <section className="bespoke-education">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <div className="bespoke-content">
                <h3 className="heading"><label>Custom Education</label> <span className="gradiant-color">Application Development</span></h3>
                <p className='sub-heading'>Mobility Infotech focuses on developing personalized education applications and software solutions designed to improve the learning experience for educators, students, and educational organizations.</p>
                <Link onClick={() => dispatch(openPopup())} className="default-btn">Let’s Design Your Project!</Link>
              </div>
            </div>
          </div>
        </div>
        <div>
          <img loading="lazy" src="/assets/home/bespoke-vec-1.webp" alt="vector" className='img-responsive bespoke-vec-1'/>
          <img loading="lazy" src="/assets/home/bespoke-vec-2.webp" alt="vector" className='img-responsive bespoke-vec-2'/>
          <img loading="lazy" src="/assets/home/bespoke-vec-3.webp" alt="vector" className='img-responsive bespoke-vec-3'/>
        </div>
      </section>
    </>
  )
}
